import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';
import { useUser } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import { isProdExactly } from '../../utils/getRunMode';

const SuccessFormModal = ({ className, closeBtn, isOpen, onClose, onSuccessModalClose, selectedProduct, lead={}, ...rest }) => {
  const messageContext = useNeuroMessages();
  const classes = classnames(className, 'successFormModal contactFormModal');

  const openAccountActionType = messageContext.getMessage('product.actionType.openAccount');
  const contactUsActionType = messageContext.getMessage('product.actionType.contactUs');
  const enrollOnlineActionType = messageContext.getMessage('product.actionType.enrollOnline');
  const getTheAppActionType = messageContext.getMessage('product.actionType.getTheApp');

  const openAccountSuccessHeader = messageContext.getMessage('openAccountSuccessHeader');
  const openAccountSuccessButton = messageContext.getMessage('openAccountSuccessButton');

  const contactUsSuccessHeader = messageContext.getMessage('contactUsSuccessHeader');
  const contactUsSuccessButton = messageContext.getMessage('contactUsSuccessButton');

  const enrollOnlineSuccessHeader = messageContext.getMessage('enrollOnlineSuccessHeader');
  const enrollOnlineSuccessButton = messageContext.getMessage('enrollOnlineSuccessButton');

  const getTheAppSuccessHeader = messageContext.getMessage('getTheAppSuccessHeader');
  const getTheAppSuccessButton = messageContext.getMessage('getTheAppSuccessButton');

  const { uuid } = useUser();

  const successHeaderText = () => {
    switch(selectedProduct.productAction) {
      case openAccountActionType:
        return openAccountSuccessHeader;
      case enrollOnlineActionType:
        return enrollOnlineSuccessHeader;
      case getTheAppActionType:
        return getTheAppSuccessHeader
      case contactUsActionType:
      default:
        return contactUsSuccessHeader;
    }
  }

  const successButtonText = () => {
    switch(selectedProduct.productAction) {
      case openAccountActionType:
        return openAccountSuccessButton;
      case enrollOnlineActionType:
        return enrollOnlineSuccessButton;
      case getTheAppActionType:
        return getTheAppSuccessButton
      case contactUsActionType:
      default:
        return contactUsSuccessButton;
    }
  }

  const getOpenAccountSuccessUrl = () => {
    const oaoBaseURL = isProdExactly() ? messageContext.getMessage('product.actionUrl.oaoProduction') : messageContext.getMessage('product.actionUrl.oaoTesting');
    const productCode = '?productCode='+messageContext.getMessage(`${selectedProduct.productId}.action.productCode`);
    const formattedPhone = lead.phone && lead.phone.replace(/[^0-9]/g, '');
    const contactInfoFromForm = '&firstName='+lead.firstName+'&lastName='+lead.lastName+'&email='+lead.email+'&phoneNo='+formattedPhone;

    return oaoBaseURL + productCode + contactInfoFromForm;
  }

  const getOnlineUrl = () => {
    switch(selectedProduct.productAction) {
      case enrollOnlineActionType:
        return messageContext.getMessage('product.actionUrl.enrollOnline');
      case getTheAppActionType:
        return messageContext.getMessage('product.actionUrl.getTheApp');
    }
  }

  const successButtonUrl = () => {
    switch(selectedProduct.productAction) {
      case openAccountActionType:
        return getOpenAccountSuccessUrl();
      case enrollOnlineActionType:
      case getTheAppActionType:
        return getOnlineUrl();
      default:
        return null;
    }
  }

  const successButton = <a href={ successButtonUrl() } className='btn btn-primary' target="_blank" > { successButtonText() } </a>;

  return (
    <Modal
      show={ isOpen }
      className={ classes }
      title={ successHeaderText() }
      onClose={ onClose }
      closeBtn={ closeBtn }
      nodeId="root"
    >

      <div className="shareResults">
        <NeuroMessage id="uuidMessage" values={ { uuid } } tagName='p' />
        <div onClick={ onSuccessModalClose }>
          { successButton }
        </div>
      </div>

    </Modal>
  );
};
SuccessFormModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default SuccessFormModal;
